module.exports = __webpack_public_path__ + "img/Forget-4.11cb4fd5.svg";